var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 15.5002C5.94006 15.5002 2.18006 12.9102 0.170059 8.75024C-0.0599414 8.28024 -0.0599414 7.72024 0.170059 7.25024C2.18006 3.09024 5.94006 0.500244 10.0001 0.500244C14.0601 0.500244 17.8201 3.09024 19.8301 7.25024C20.0601 7.72024 20.0601 8.28024 19.8301 8.75024C17.8201 12.9102 14.0601 15.5002 10.0001 15.5002ZM10.0001 2.25024C6.66006 2.25024 3.52006 4.45024 1.82006 7.99024C3.52006 11.5502 6.66006 13.7502 10.0001 13.7502C13.3401 13.7502 16.4801 11.5502 18.1801 8.02024C16.4801 4.46024 13.3401 2.26024 10.0001 2.26024V2.25024Z",
    fill: "#547089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.9402C7.79 11.9402 6 10.1502 6 7.94025C6 5.73025 7.79 3.94025 10 3.94025C12.21 3.94025 14 5.73025 14 7.94025C14 10.1502 12.21 11.9402 10 11.9402ZM10 5.94025C8.9 5.94025 8 6.84025 8 7.94025C8 9.04025 8.9 9.94025 10 9.94025C11.1 9.94025 12 9.04025 12 7.94025C12 6.84025 11.1 5.94025 10 5.94025Z",
    fill: "#547089"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.7ad3c4997473dccafe736305a7702654.svg";
export { ForwardRef as ReactComponent };